import { render, staticRenderFns } from "./AdminFaqs.vue?vue&type=template&id=602279b1&scoped=true"
import script from "./AdminFaqs.vue?vue&type=script&lang=js"
export * from "./AdminFaqs.vue?vue&type=script&lang=js"
import style0 from "./AdminFaqs.vue?vue&type=style&index=0&id=602279b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602279b1",
  null
  
)

export default component.exports